import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  updateProviderSettings,
  UpdateProviderSettingsParams,
} from "@/api/settings/updateProviderSettings";
import { SettingsQueryKeys } from "@/tanstackQuery/queries/settings";
import { Settings } from "@/types/Settings";

export interface UpdateProviderSettingsOptions {
  onSuccess?: (data: Settings) => void;
  onError?: (error: Error) => void;
}

// The football provider lives in the global settings row; a successful save
// refreshes it (fire-and-forget, so the caller's toast is not held back by
// the refetch). A failed save leaves the cache alone: the caller reverts its
// own mirror from the settings it already has.
export const useUpdateProviderSettings = (
  options?: UpdateProviderSettingsOptions
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateProviderSettingsParams) =>
      updateProviderSettings(params),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [SettingsQueryKeys.Settings] });
      options?.onSuccess?.(data);
    },
    onError: options?.onError,
  });
};
